import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './TenantPermittedDomains.scss';

interface PermittedDomainsReadOnlyProps {
    domains: string[];
    isEmpty?: boolean;
    remainingCount?: number;
}

export const PermittedDomainsReadOnly: React.FC<PermittedDomainsReadOnlyProps> = ({
    domains,
    isEmpty,
    remainingCount = 0,
}) => {
    const { t } = useTranslation();
    
    if (isEmpty) {
        return (
            <div className={styles.EmptyState} data-testid="empty-state">
                {t('web.admin.channel.profile.settings.permittedDomains.empty')}
            </div>
        );
    }

    return (
        <div className={styles.DomainListContainer} data-testid="domain-list">
            <label className={styles.DomainLabel}>
                {t('web.admin.channel.profile.settings.permittedDomains.domainsLabel')}
            </label>
            <div className={styles.DomainList}>
                {domains.map((domain) => (
                    <span key={domain} className={styles.DomainItem}>
                        {domain}
                    </span>
                ))}
                {remainingCount > 0 && (
                    <span className={styles.DomainItem} data-testid="remaining-count">
                        +{remainingCount} {t('web.admin.channel.profile.settings.permittedDomains.more', { count: remainingCount })}
                    </span>
                )}
            </div>
        </div>
    );
};

